import React from 'react';

export default () => <div class="loading-container"><p>Loading...</p></div>;